/**
 * @fileoverview POST handler for the "/integrations/direct/cdi/import-syncs/connection" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { integrationsDirectCdiImportSyncsConnectionCacheKeys } from "./constants";
import type {
  PostIntegrationsDirectCdiImportSyncsConnectionProps,
  IntegrationsDirectCdiImportSyncsConnectionResult,
} from "./types";

export const postIntegrationsDirectCdiImportSyncsConnection = reactQueryMutationAdapter(
  integrationsDirectCdiImportSyncsConnectionCacheKeys,
  (
    props: PostIntegrationsDirectCdiImportSyncsConnectionProps
  ): Promise<IntegrationsDirectCdiImportSyncsConnectionResult> => {
    // manipulate props here as needed { warehouse_id, param2, param3 }

    return fetch("/integrations/direct/cdi/import-syncs/connection", "POST", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
